import { Component } from '@angular/core';
import { ReturnsListPhComponent } from '../../../../components/user-dashboard-component/returns-list-ph-component/returns-list-ph-component';

@Component({
  selector: 'app-returns-list',
  imports: [ReturnsListPhComponent],
  templateUrl: './returns-list.html',
  styleUrl: './returns-list.scss',
})
export class ReturnsList {

}
